import { IconHouse } from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'
import { type ShippingLocation as ShippingLocationType } from 'typings'
import { useFormStateContext } from '../../../../providers'
import { useDrawerState } from '../../../Drawer'
import { messages } from './messages'

import { useConditions } from '../useConditions'
import { ShippingLocationEditor } from './Editor'
import { ShippingLocationView } from './View'

type ShippingLocationProps = {
  name: string
}

export function ShippingLocation(props: ShippingLocationProps) {
  const { name } = props
  const drawerState = useDrawerState()
  const { formatMessage: i18n } = useIntl()
  const { form } = useFormStateContext()

  useConditions({
    name,
    onEdit: drawerState.show,
    label: i18n(messages.title),
    icon: <IconHouse />,
  })

  const shippingLocation: ShippingLocationType = useWatch({ form, name }) ?? {
    shippingCountries: [],
    zipCodeRanges: [],
  }

  const handleRemove = () => form.setValue(name, undefined)

  const handleSave = (config: ShippingLocationType) => {
    const { shippingCountries, zipCodeRanges } = config

    form.setValue(
      name,
      shippingCountries.length || zipCodeRanges.length ? config : undefined
    )
  }

  return (
    <>
      <ShippingLocationView
        config={shippingLocation}
        onEdit={drawerState.show}
        onRemove={handleRemove}
      />

      <ShippingLocationEditor
        drawerState={drawerState}
        initialValues={shippingLocation}
        onSave={handleSave}
      />
    </>
  )
}
